module.exports = __webpack_public_path__ + "static/media/teaching_server_bg.d58b0a89.png";